import React from 'react';
import './notFoundPage.module.scss';

export const ErrorPage = () => (
  <div styleName="not-found-page" id="error-page">
    <div styleName="message-box">
      ページの表示中にエラーが発生しました。 お手数ですが、ページを再読み込みしてください。
      <br />
      <br />
      <a
        href={window.location.href}
        styleName="go-home-link"
        onClick={(e) => {
          e.preventDefault();
          window.location.reload();
        }}
      >
        再読み込み
      </a>
    </div>
  </div>
);
